import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkeletonCard = _resolveComponent("SkeletonCard")!
  const _component_SkeletonRow = _resolveComponent("SkeletonRow")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["skel-list", `skel-list--${_ctx.variant}`])
  }, [
    (_ctx.variant === 'card')
      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.count, (i) => {
          return (_openBlock(), _createBlock(_component_SkeletonCard, { key: i }))
        }), 128))
      : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.count, (i) => {
          return (_openBlock(), _createBlock(_component_SkeletonRow, {
            key: i,
            columns: _ctx.columns
          }, null, 8, ["columns"]))
        }), 128))
  ], 2))
}